import React, { Component } from "react"
import request from "superagent"
import { Formik, Field, Form } from "formik"
import completeFields from "models/complete"
import fieldStatus from "helpers/fieldStatus"
import * as Yup from "yup"
import submitData from "helpers/submitData"
import DateField from "components/DateField"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"

class CompleteModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: completeFields,
			noticeStatus: false,
			noticeDropStatus: false,
			files: {
				notice: [],
			},
			data: {
				address: "",
			},
		}
	}

	validation = () => {
		let model = {
			complete_date: Yup.mixed().required("Required"),
		}
		return Yup.object().shape(model)
	}

	submitClasses = f => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}


	formLayout = f => {
		return (
			<div>
				{/* console.log(f) */}
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("complete_date", f)}>
							<label htmlFor="complete_date">
								Complete Date <sup>*</sup>
							</label>
							{f.errors.complete_date && f.touched.complete_date && (
								<div className="form__message">{f.errors.complete_date}</div>
							)}
							<DateField
								name="complete_date"
								value={f.values.complete_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.complete_date}
								error={f.errors.complete_date}
								startDate={this?.props?.data?.start_date}
								blockFuture={true}
							/>
						</li>
					</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	render() {
		console.log(this.props.data)
		return (
			<div className="modal">
				<h3>Add Completion: {this.props.data.address}</h3>
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					enableReinitialize
					//validateOnMount={true}
					onSubmit={values => {
						values.id = this.props.data.id
						submitData("inputComplete", values)
							.then(data => {
								this.props.notify(data, this.props.name)
							})
							.catch(e => {
								this.props.notify(e, this.props.name)
							})
					}}
					render={f => this.formLayout(f)}
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(
	mapStateToProps,
	matchDispatchToProps
)(CompleteModal)
